// extracted by mini-css-extract-plugin
module.exports = {"viewed__wrapper":"styles_viewed__wrapper__JpPf1","item__wrapper":"styles_item__wrapper__18Ck0"};